export default function (objectWithUndefined) {
    return Object.keys(objectWithUndefined)
        .forEach(key => objectWithUndefined[key] === undefined && delete objectWithUndefined[key]);
}
